import { TextField } from "@mui/material";

function SimpleTextField({key, label, name, value, onChange, error, required }) {
  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      size="small"
      name={name}
      value={value}
        onChange={onChange}
     key={key}
      error={error}
      required = {required}
      sx={{
        "& .MuiFormLabel-asterisk": {
          color: "red",
        },
      }}
      helperText={"Allowed: A-Z, 0-9, _, -. Max 100 chars."}
      FormHelperTextProps={{
        sx: {
          fontSize: "0.7rem",
        },
      }}
    />
  );
}
export default SimpleTextField;
